import { render } from "./Error.vue?vue&type=template&id=4de8d09b&scoped=true&ts=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=4de8d09b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_mpay_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de8d09b"]])

export default __exports__